var {AmpersandView} = require('catalog/libs');

var template = require('../templates/hpe.productlist.facet.template.tpl');
var FilterGroupCollectionView = require('./hpe.productlist.filtergroup.view');

/**
 * collection of facets (container view)
  * view hierarchy: filterlist > facet collection (this) > facet > filtergroup collection > filter group > filter collection > filter
 */
var FacetCollectionView = AmpersandView.extend({

    render: function(opts) {
        this.renderCollection(this.collection, function(options) {
            return new FacetView(options);
        }, this.el, opts);
        return this;
    }
});

/**
 * facet view
  * view hierarchy: filterlist > facet collection > facet (this) > filtergroup collection > filter group > filter collection > filter
 */
var FacetView = AmpersandView.extend({
    template: template,
    bindings: {
        'model.label': {
            type: 'text',
            selector: 'legend'
        }
    },

    initialize: function() {
        //remove the existing filters rendered by AEM
        //$('.filterlist-filter-static').remove();
    },
    subviews: {
        filtergroups: {
            selector: '.filterlist-group-content',
            waitFor: 'model.facets',
            prepareView: function(el) {
                return new FilterGroupCollectionView({
                    el: el,
                    collection: this.model.facets
                });
            }
        }
    }
});

module.exports = FacetCollectionView;
